module.exports = __webpack_public_path__ + "img/colors_2.70327c5b.png";